import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';

import { FaTrophy, FaUserGraduate } from "react-icons/fa";
//import { MdAnnouncement } from "react-icons/md";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BiLineChartDown } from "react-icons/bi";
import { MdCalendarToday } from 'react-icons/md';

import { CapsNotices } from "./TabPages/CapsNotices";
import { CapsDates } from "./TabPages/CapsDates";
import { NIRFRankings } from "./TabPages/NIRFRankings";
import { Seats } from "./TabPages/Seats";
import { Cutoffs } from "./TabPages/Cutoffs";
import "react-tabs/style/react-tabs.css";
import { SeatSearchProvider } from "../store/SeatSearchContextProvider";
import { CutoffSearchProvider } from "../store/CutoffSearchContextProvider";

// Tab index to path mapping
const tabPaths = [
  '/capzone/nirf-rankings',
  '/capzone/caps-dates',
  '/capzone/caps-notices',
  '/capzone/seat-matrix',
  '/capzone/rank-cutoffs'
];

// props contains tabid.
export function CAPTabs(props) { 
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  const iconClass = "inline-block w-4 h-4 mr-1" 
  
  useEffect(() => {
    setTabIndex(props.tabId);
  }, [props]);
  
  const handleTabSelect = (index) => {
    setTabIndex(index);
    // Update URL to match selected tab
    navigate(tabPaths[index], { replace: true });
  };
  
  return (
    <div className="w-full h-full m-2 transition-all ease-in-out border-2">
      <Tabs
        defaultFocus={true}
        selectedIndex={tabIndex}
        onSelect={handleTabSelect}
        id="controlled-tabs"
        className="sm:text-xs lg:text-sm md:text-xs font-normal text-primary-900 bg-transparent"
        selectedTabClassName="border-2 bg-primary-500/10 text-primary-900 border-primary-900 rounded-t-2xl font-extrabold font-stretch"
      >
        <TabList className="flex space-x-1 m-1 border-b-primary-500 border-b-2 round" id="TabList">
          <Tab id="rankings" >
            <div className="flex items-center space-x-2">
              <FaTrophy className={`${iconClass} text-amber-500 drop-shadow-[0_0_1px_black]`}/>
              NIRF Ranks
            </div>
          </Tab>
          <Tab id="capsdates">
            <div className="flex items-center space-x-2">
              <MdCalendarToday  className={`${iconClass} text-red-500`} />
              CAP Schedules
            </div>
          </Tab>
          <Tab id="capsnotices">
            <div className="flex items-center space-x-2">
              <AiOutlineClockCircle  className={`${iconClass} text-red-500`} />
              CAP Notices
            </div>
          </Tab>
          <Tab id="seats">
            <div className="flex items-center space-x-2">
              <FaUserGraduate  className={`${iconClass} text-black`} />
              Seats
            </div>
          </Tab>
          <Tab id="cutoffs">
            <div className="flex items-center space-x-2">
              <BiLineChartDown  className={`${iconClass} text-green-700`}  />
              CutOffs
            </div>
          </Tab>
        </TabList>
        
        <TabPanel>
          <div className="flex flex-row">
            <NIRFRankings />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="flex flex-row">
            <CapsDates />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="flex flex-row">
            <CapsNotices />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="flex flex-row">
            <SeatSearchProvider>
              <Seats />
            </SeatSearchProvider>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="flex flex-row">
            <CutoffSearchProvider>
              <Cutoffs />
            </CutoffSearchProvider>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
}
